// services/analytics.service.ts
import {Injectable} from '@angular/core'
import {environment} from 'environments/environment'

declare const dataLayer: any[]

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor() {
    if (environment.gtmId) {
      this.initializeGTM()
    }
  }

  private initializeGTM(): void {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${environment.gtmId}`
    document.head.appendChild(script)

    window['dataLayer'] = window['dataLayer'] || []
  }

  sendEvent(eventName: string, eventParams: any = {}): void {
    if (environment.gtmId) {
      dataLayer.push({
        event: eventName,
        ...eventParams,
      })
    }
  }

  trackPageView(path: string): void {
    if (environment.gtmId) {
      dataLayer.push({
        event: 'page_view',
        page_path: path,
      })
    }
  }
}
